/** Strict `=== 'true'` parser. An unset or malformed env value yields false. */
export function performanceV2Enabled(
  env: { VITE_PERFORMANCE_V2_ENABLED?: string } = import.meta.env
): boolean {
  return env.VITE_PERFORMANCE_V2_ENABLED === 'true';
}
